import styled from 'styled-components';

import { media } from '~/src/styles-constants';

interface FlexProps {
  $inline?: boolean;
}

interface PromoPriceProps {
  $inline?: boolean;
}

export const Container = styled.div<FlexProps>`
  display: flex;
  flex-direction: ${({ $inline }) => ($inline ? 'row' : 'column')};
  align-items: ${({ $inline }) => ($inline ? 'center' : 'flex-start')};
`;

export const OriginalPrice = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 400;
  text-decoration: line-through;
  color: ${({ theme }) => theme.palette.common.BLACK};
  font-size: 12px;
  line-height: 14px;

  ${media.S`
    font-size: 14px;
  `}
`;

export const PromoPrice = styled.div<PromoPriceProps>`
  background-color: ${({ theme }) => theme.palette.common.PROMOTION};
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.palette.common.BLACK};

  border-radius: 4px;
  margin: ${({ $inline }) => ($inline ? '0px 7px 0 4px' : '0px')};
  font-size: 14px;
  font-weight: 500;
  padding: 2px;
  height: 18px;
  line-height: 14px;

  ${media.S<PromoPriceProps>`
    font-size: 20px;
    margin: ${({ $inline }) => ($inline ? '0 8px' : '0px')};
    padding: 2px;
    height: 24px;
    line-height: 20px;
  `}
`;
